export const couponConfig = {
  274: {
    // 是否显示我的券包入口
    isCoupon: true,
    // 是否显示VIP积分按钮
    isVipScore: true,
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: 'Douluo Dalu : สัประยุทธ์วิญญาจารย์', //游戏名，用在规则里替换
      ruleNum: 13, // 规则数量
      gamePrefix: 'dl3dvn',
      table: [
        ['100', '7%OFF${couponCoupon}*1', '5%OFF${couponCoupon}*10'],
        [
          '1000',
          '9%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n7%OFF${couponCoupon}*5'
        ],
        [
          '5000',
          '11%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n9%OFF${couponCoupon}*3'
        ],
        [
          '10000',
          '13%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n11%OFF${couponCoupon}*2'
        ],
        [
          '20000',
          '15%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n13%OFF${couponCoupon}*1'
        ]
      ],
      link: 'https://docs.google.com/spreadsheets/d/1YZ1XybJuJOLEYIIIx_mOnehr7GNKLcQHzpZYgtlQOZk/edit?usp=sharing'
    }
  },
  251: {
    // 是否显示我的券包入口
    isCoupon: true,
    // 是否显示VIP积分按钮
    isVipScore: true,
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: '斗羅大陸3D：魂師對決', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw',
      table: [
        ['100', '5%OFF${couponCoupon}*1', '5%OFF${couponCoupon}*1'],
        [
          '1000',
          '7%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n5%OFF${couponCoupon}*1'
        ],
        [
          '5000',
          '9%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n7%OFF${couponCoupon}*1'
        ],
        [
          '10000',
          '10%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n9%OFF${couponCoupon}*1'
        ],
        [
          '20000',
          '15%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n10%OFF${couponCoupon}*1'
        ]
      ],
      link: 'https://docs.google.com/spreadsheets/d/1VNfVmjrkP_5VEfLCH8myD-KLgF8j2pyp--5AqK00zuY/edit#gid=0'
    }
  },
  213: {
    // 是否显示我的券包入口
    isCoupon: true,
    // 是否显示VIP积分按钮
    isVipScore: true,
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: 'Trading Legend-รวยรวยรวย', //游戏名，用在规则里替换
      ruleNum: 12, // 规则数量
      gamePrefix: 'dzg',
      table: [
        ['100', '7%OFF${couponCoupon}*1', '5%OFF${couponCoupon}*10'],
        [
          '1000',
          '9%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n7%OFF${couponCoupon}*5'
        ],
        [
          '5000',
          '11%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n9%OFF${couponCoupon}*3'
        ],
        [
          '10000',
          '13%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n11%OFF${couponCoupon}*2'
        ],
        [
          '20000',
          '15%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n13%OFF${couponCoupon}*1'
        ]
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit?usp=sharing'
    }
  },
  209: {
    // 是否显示我的券包入口
    isCoupon: true,
    // 是否显示VIP积分按钮
    isVipScore: true,
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: '商人放浪記', //游戏名，用在规则里替换
      ruleNum: 12, // 规则数量
      gamePrefix: 'dzg',
      table: [
        ['100', '7%OFF${couponCoupon}*1', '5%OFF${couponCoupon}*10'],
        [
          '1000',
          '9%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n7%OFF${couponCoupon}*5'
        ],
        [
          '5000',
          '11%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n9%OFF${couponCoupon}*3'
        ],
        [
          '10000',
          '13%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n11%OFF${couponCoupon}*2'
        ],
        [
          '20000',
          '15%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n13%OFF${couponCoupon}*1'
        ]
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit?usp=sharing'
    }
  },
  211: {
    // 是否显示我的券包入口
    isCoupon: true,
    // 是否显示VIP积分按钮
    isVipScore: true,
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: '갑부: 장사의 시대', //游戏名，用在规则里替换
      ruleNum: 12, // 规则数量
      gamePrefix: 'dzg',
      table: [
        ['100', '7%OFF${couponCoupon}*1', '5%OFF${couponCoupon}*10'],
        [
          '1000',
          '10%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n7%OFF${couponCoupon}*5'
        ],
        [
          '5000',
          '12%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n10%OFF${couponCoupon}*3'
        ],
        [
          '10000',
          '14%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n12%OFF${couponCoupon}*2'
        ],
        [
          '20000',
          '16%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n14%OFF${couponCoupon}*1'
        ]
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit?usp=sharing'
    }
  },
  175: {
    // 是否显示我的券包入口
    isCoupon: true,
    // 是否显示VIP积分按钮
    isVipScore: true,
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: 'Puzzles & Conquest', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw',
      table: [
        ['20', '7%OFF${couponCoupon}*1', '5%OFF${couponCoupon}*10'],
        [
          '200',
          '9%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n7%OFF${couponCoupon}*5'
        ],
        [
          '500',
          '11%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n9%OFF${couponCoupon}*3'
        ],
        [
          '1000',
          '13%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n11%OFF${couponCoupon}*2'
        ],
        [
          '2000',
          '15%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n13%OFF${couponCoupon}*1'
        ]
      ],
      link: 'https://docs.google.com/spreadsheets/d/1YZ1XybJuJOLEYIIIx_mOnehr7GNKLcQHzpZYgtlQOZk/edit?usp=sharing'
    }
  },
  // 帝国SLG全球版
  269: {
    // 是否显示我的券包入口
    isCoupon: true,
    // 是否显示VIP积分按钮
    isVipScore: true,
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: 'Game of Empires: Warring Realms', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      gamePrefix: 'dl3dtw',
      table: [
        ['100', '7%OFF${couponCoupon}*1', '5%OFF${couponCoupon}*10'],
        [
          '1000',
          '9%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n7%OFF${couponCoupon}*5'
        ],
        [
          '5000',
          '11%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n9%OFF${couponCoupon}*3'
        ],
        [
          '10000',
          '13%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n11%OFF${couponCoupon}*2'
        ],
        [
          '20000',
          '15%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n13%OFF${couponCoupon}*1'
        ]
      ],
      link: 'https://docs.google.com/spreadsheets/d/1YZ1XybJuJOLEYIIIx_mOnehr7GNKLcQHzpZYgtlQOZk/edit?usp=sharing'
    }
  },
  321: {
    // 是否显示我的券包入口
    isCoupon: true,
    // 是否显示VIP积分按钮
    isVipScore: true,
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: '下町ドリーム', //游戏名，用在规则里替换
      ruleNum: 13, // 规则数量
      gamePrefix: 'swsjp',
      table: [
        ['100', '7%OFF${couponCoupon}*1', '5%OFF${couponCoupon}*10'],
        [
          '1000',
          '9%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n7%OFF${couponCoupon}*5'
        ],
        [
          '5000',
          '11%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n9%OFF${couponCoupon}*3'
        ],
        [
          '10000',
          '13%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n11%OFF${couponCoupon}*2'
        ],
        [
          '20000',
          '15%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n13%OFF${couponCoupon}*1'
        ]
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0'
    }
  }
};
